export default __webpack_public_path__ + "static/media/no-products-found.7425bfa2.png";